import Column from '@components/Column';
import Image from '@components/Image';
import Text from '@components/Text';
import styled from '@emotion/styled';
import ColorContext from '@providers/ColorProvider/context/ColorContext';
import { Link } from '@stackflow/link';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import coolImg from './cool_img.png';
import PlusIcon from './PlusIcon';
import warmImg from './warm_img.png';

function Blank() {
    const { t } = useTranslation('prepaidCard');
    const { grayTheme } = useContext(ColorContext);
    return (
        <Container fullWidth
            as='section'
            align='center'>
            <BlankImage src={grayTheme === 'WARM' ? warmImg : coolImg}
                width={256}
                height={256}
                alt={t('blank.imageAlt')} />
            <Text size='lg'>{t('blank.noCard')}</Text>
            <Link activityParams={{ type: 'BUY' }}
                activityName='PrepaidCardImagesActivity' >
                <Card justify='center'
                    align='center'
                    spacing={4} >
                    <AddButton>
                        <PlusIcon/>
                    </AddButton>
                    <Text size='lg'>{t('blank.buyNewCard')}</Text>
                </Card>
            </Link>
        </Container>
    );
}

const Container = styled(Column)`
    background-color: var(--color-gray2);
    padding-bottom: 44px;
`;

const BlankImage = styled(Image)`
    margin-bottom: 4px;
    margin-top: -8px;
`;

const Card = styled(Column)`
    background-color: var(--color-white);
    border: 2px dashed var(--color-gray4);
    border-radius: 6px;
    cursor: pointer;
    margin-top: 40px;
    min-height: 136px;
    min-width: 210px;
`;

const AddButton = styled.button`
    align-items: center;
    background-color: var(--color-gray2);
    border-radius: 15px;
    display: flex;
    height: 30px;
    justify-content: center;
    width: 30px;
`;

export default Blank;
